/*
 * Copyright (c) 2020-06-29 Qoder. All rights reserved.
 */
import axios from 'axios';

/**
 * 学生端学费查询 API
 */

/** 获取学费汇总 */
export function getFeeSummary() {
  return axios.get('/biz/student-fee/summary');
}

/** 获取缴费明细（分页） */
export function getFeeDetails(params) {
  return axios.get('/biz/student-fee/details', { params });
}



// WEBPACK FOOTER //
// ./src/api/fee.js